import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FeatureCard } from '@unmind/design-system';
import RoutePath from '../../App/RoutePath';
import { tracking } from '../../App/Tracking';

interface Props {
  source: string;
}

const WellbeingTrackerCTA = ({ source }: Props) => {
  const { t: translate } = useTranslation('track');

  const onCTAClick = () =>
    tracking.track('wellbeing-tracker-cta-clicked', {
      source,
    });

  return (
    <FeatureCard
      titleAsChild
      description={translate('wellbeing.wellbeing_tracker_cta.description')}
      icon={{
        name: 'arrow-right',
        variant: 'icon-button',
      }}
    >
      <Link to={RoutePath.UnmindIndex} onClick={onCTAClick}>
        {translate('wellbeing.wellbeing_tracker_cta.title')}
      </Link>
    </FeatureCard>
  );
};

export default WellbeingTrackerCTA;
